/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../models/GQL_API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAccount = /* GraphQL */ `query GetAccount($id: ID!) {
  getAccount(id: $id) {
    id
    logo {
      id
      mediaID
      fileUrl
      filename
      filetype
      fileSize
      alternativeText
      caption
      description
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    deleted
    createdAt
    createdByID
    createdByName
    callCenterEmployeesIds
    updatedAt
    _version
    _deleted
    _lastChangedAt
    accountLogoId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountQueryVariables,
  APITypes.GetAccountQuery
>;
export const listAccounts = /* GraphQL */ `query ListAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      deleted
      createdAt
      createdByID
      createdByName
      callCenterEmployeesIds
      updatedAt
      _version
      _deleted
      _lastChangedAt
      accountLogoId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsQueryVariables,
  APITypes.ListAccountsQuery
>;
export const syncAccounts = /* GraphQL */ `query SyncAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAccounts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      deleted
      createdAt
      createdByID
      createdByName
      callCenterEmployeesIds
      updatedAt
      _version
      _deleted
      _lastChangedAt
      accountLogoId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAccountsQueryVariables,
  APITypes.SyncAccountsQuery
>;
export const accountsByDomain = /* GraphQL */ `query AccountsByDomain(
  $domain: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  accountsByDomain(
    domain: $domain
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      deleted
      createdAt
      createdByID
      createdByName
      callCenterEmployeesIds
      updatedAt
      _version
      _deleted
      _lastChangedAt
      accountLogoId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AccountsByDomainQueryVariables,
  APITypes.AccountsByDomainQuery
>;
export const getConcept = /* GraphQL */ `query GetConcept($id: ID!) {
  getConcept(id: $id) {
    id
    accountID
    name
    kiosks
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConceptQueryVariables,
  APITypes.GetConceptQuery
>;
export const listConcepts = /* GraphQL */ `query ListConcepts(
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
) {
  listConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      name
      kiosks
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConceptsQueryVariables,
  APITypes.ListConceptsQuery
>;
export const syncConcepts = /* GraphQL */ `query SyncConcepts(
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncConcepts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      name
      kiosks
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncConceptsQueryVariables,
  APITypes.SyncConceptsQuery
>;
export const accountConcepts = /* GraphQL */ `query AccountConcepts(
  $accountID: String!
  $createdAtDeleted: ModelConceptByAccountCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
) {
  accountConcepts(
    accountID: $accountID
    createdAtDeleted: $createdAtDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      name
      kiosks
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AccountConceptsQueryVariables,
  APITypes.AccountConceptsQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    accountID
    conceptID
    username
    email
    email_verified
    phone_number
    phone_number_verified
    cardCodes
    cardCode
    cardCodeID
    name
    nickname
    given_name
    middle_name
    family_name
    address
    birthdate
    gender
    picture
    preferred_username
    locale
    website
    zoneinfo
    verification_code
    flags
    flagsName
    interests
    interestsName
    facebook
    instagram
    group
    phones
    status
    stats
    total_points
    points_history
    tier
    tier_name
    points_balance
    total_spending
    orders_count
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const syncUsers = /* GraphQL */ `query SyncUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncUsersQueryVariables, APITypes.SyncUsersQuery>;
export const usersByEmail = /* GraphQL */ `query UsersByEmail(
  $email: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmail(
    email: $email
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByEmailQueryVariables,
  APITypes.UsersByEmailQuery
>;
export const usersByPhoneNumber = /* GraphQL */ `query UsersByPhoneNumber(
  $phone_number: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByPhoneNumber(
    phone_number: $phone_number
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByPhoneNumberQueryVariables,
  APITypes.UsersByPhoneNumberQuery
>;
export const usersByCardCode = /* GraphQL */ `query UsersByCardCode(
  $cardCode: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByCardCode(
    cardCode: $cardCode
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByCardCodeQueryVariables,
  APITypes.UsersByCardCodeQuery
>;
export const userByCard = /* GraphQL */ `query UserByCard(
  $cardCodeID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByCard(
    cardCodeID: $cardCodeID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByCardQueryVariables,
  APITypes.UserByCardQuery
>;
export const userSortedByOrders = /* GraphQL */ `query UserSortedByOrders(
  $deleted: String!
  $orders_count: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userSortedByOrders(
    deleted: $deleted
    orders_count: $orders_count
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      username
      email
      email_verified
      phone_number
      phone_number_verified
      cardCodes
      cardCode
      cardCodeID
      name
      nickname
      given_name
      middle_name
      family_name
      address
      birthdate
      gender
      picture
      preferred_username
      locale
      website
      zoneinfo
      verification_code
      flags
      flagsName
      interests
      interestsName
      facebook
      instagram
      group
      phones
      status
      stats
      total_points
      points_history
      tier
      tier_name
      points_balance
      total_spending
      orders_count
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserSortedByOrdersQueryVariables,
  APITypes.UserSortedByOrdersQuery
>;
export const getCardCode = /* GraphQL */ `query GetCardCode($id: ID!) {
  getCardCode(id: $id) {
    id
    userID
    code
    startDate
    endDate
    status
    cardID
    tier
    tier_name
    points_balance
    createdAt
    createdByName
    deleted
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCardCodeQueryVariables,
  APITypes.GetCardCodeQuery
>;
export const listCardCodes = /* GraphQL */ `query ListCardCodes(
  $filter: ModelCardCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listCardCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      code
      startDate
      endDate
      status
      cardID
      tier
      tier_name
      points_balance
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCardCodesQueryVariables,
  APITypes.ListCardCodesQuery
>;
export const syncCardCodes = /* GraphQL */ `query SyncCardCodes(
  $filter: ModelCardCodeFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCardCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      code
      startDate
      endDate
      status
      cardID
      tier
      tier_name
      points_balance
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncCardCodesQueryVariables,
  APITypes.SyncCardCodesQuery
>;
export const cardCodesByUserIDAndStartDate = /* GraphQL */ `query CardCodesByUserIDAndStartDate(
  $userID: ID!
  $startDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCardCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  cardCodesByUserIDAndStartDate(
    userID: $userID
    startDate: $startDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      code
      startDate
      endDate
      status
      cardID
      tier
      tier_name
      points_balance
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CardCodesByUserIDAndStartDateQueryVariables,
  APITypes.CardCodesByUserIDAndStartDateQuery
>;
export const cardByCode = /* GraphQL */ `query CardByCode(
  $code: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCardCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  cardByCode(
    code: $code
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      code
      startDate
      endDate
      status
      cardID
      tier
      tier_name
      points_balance
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CardByCodeQueryVariables,
  APITypes.CardByCodeQuery
>;
export const getSocialLink = /* GraphQL */ `query GetSocialLink($id: ID!) {
  getSocialLink(id: $id) {
    id
    name
    icon
    slug
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSocialLinkQueryVariables,
  APITypes.GetSocialLinkQuery
>;
export const listSocialLinks = /* GraphQL */ `query ListSocialLinks(
  $filter: ModelSocialLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  listSocialLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      icon
      slug
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSocialLinksQueryVariables,
  APITypes.ListSocialLinksQuery
>;
export const syncSocialLinks = /* GraphQL */ `query SyncSocialLinks(
  $filter: ModelSocialLinkFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSocialLinks(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      icon
      slug
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSocialLinksQueryVariables,
  APITypes.SyncSocialLinksQuery
>;
export const activeLinks = /* GraphQL */ `query ActiveLinks(
  $name: String!
  $createdAtDeleted: ModelSocialLinkByNameCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSocialLinkFilterInput
  $limit: Int
  $nextToken: String
) {
  activeLinks(
    name: $name
    createdAtDeleted: $createdAtDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      icon
      slug
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveLinksQueryVariables,
  APITypes.ActiveLinksQuery
>;
export const getFeature = /* GraphQL */ `query GetFeature($id: ID!) {
  getFeature(id: $id) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureQueryVariables,
  APITypes.GetFeatureQuery
>;
export const listFeatures = /* GraphQL */ `query ListFeatures(
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  listFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeaturesQueryVariables,
  APITypes.ListFeaturesQuery
>;
export const syncFeatures = /* GraphQL */ `query SyncFeatures(
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncFeatures(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncFeaturesQueryVariables,
  APITypes.SyncFeaturesQuery
>;
export const searchFeatures = /* GraphQL */ `query SearchFeatures(
  $name: String!
  $createdAtDeleted: ModelFeatureByNameCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  searchFeatures(
    name: $name
    createdAtDeleted: $createdAtDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFeaturesQueryVariables,
  APITypes.SearchFeaturesQuery
>;
export const activeFeatures = /* GraphQL */ `query ActiveFeatures(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  activeFeatures(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveFeaturesQueryVariables,
  APITypes.ActiveFeaturesQuery
>;
export const getLanguage = /* GraphQL */ `query GetLanguage($id: ID!) {
  getLanguage(id: $id) {
    id
    name
    code
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLanguageQueryVariables,
  APITypes.GetLanguageQuery
>;
export const listLanguages = /* GraphQL */ `query ListLanguages(
  $filter: ModelLanguageFilterInput
  $limit: Int
  $nextToken: String
) {
  listLanguages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      code
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLanguagesQueryVariables,
  APITypes.ListLanguagesQuery
>;
export const syncLanguages = /* GraphQL */ `query SyncLanguages(
  $filter: ModelLanguageFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncLanguages(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      code
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncLanguagesQueryVariables,
  APITypes.SyncLanguagesQuery
>;
export const activeLanguages = /* GraphQL */ `query ActiveLanguages(
  $name: String!
  $createdAtDeleted: ModelLanguageByNameCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLanguageFilterInput
  $limit: Int
  $nextToken: String
) {
  activeLanguages(
    name: $name
    createdAtDeleted: $createdAtDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      code
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveLanguagesQueryVariables,
  APITypes.ActiveLanguagesQuery
>;
export const getMedia = /* GraphQL */ `query GetMedia($id: ID!) {
  getMedia(id: $id) {
    id
    accountID
    fileUrl
    filename
    filetype
    fileSize
    alternativeText
    caption
    description
    attachments
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMediaQueryVariables, APITypes.GetMediaQuery>;
export const listMedia = /* GraphQL */ `query ListMedia(
  $filter: ModelMediaFilterInput
  $limit: Int
  $nextToken: String
) {
  listMedia(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      fileUrl
      filename
      filetype
      fileSize
      alternativeText
      caption
      description
      attachments
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListMediaQueryVariables, APITypes.ListMediaQuery>;
export const syncMedia = /* GraphQL */ `query SyncMedia(
  $filter: ModelMediaFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncMedia(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      fileUrl
      filename
      filetype
      fileSize
      alternativeText
      caption
      description
      attachments
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncMediaQueryVariables, APITypes.SyncMediaQuery>;
export const getAttachment = /* GraphQL */ `query GetAttachment($id: ID!) {
  getAttachment(id: $id) {
    id
    mediaID
    fileUrl
    filename
    filetype
    fileSize
    alternativeText
    caption
    description
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttachmentQueryVariables,
  APITypes.GetAttachmentQuery
>;
export const listAttachments = /* GraphQL */ `query ListAttachments(
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttachments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      mediaID
      fileUrl
      filename
      filetype
      fileSize
      alternativeText
      caption
      description
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAttachmentsQueryVariables,
  APITypes.ListAttachmentsQuery
>;
export const syncAttachments = /* GraphQL */ `query SyncAttachments(
  $filter: ModelAttachmentFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAttachments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      mediaID
      fileUrl
      filename
      filetype
      fileSize
      alternativeText
      caption
      description
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAttachmentsQueryVariables,
  APITypes.SyncAttachmentsQuery
>;
export const getGroup = /* GraphQL */ `query GetGroup($id: ID!) {
  getGroup(id: $id) {
    id
    accountID
    name
    description
    color
    requireApproval
    status
    agents
    groupSettings
    numToUpgrade
    numToDowngrade
    upgradeGroup
    downgradeGroup
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGroupQueryVariables, APITypes.GetGroupQuery>;
export const listGroups = /* GraphQL */ `query ListGroups(
  $filter: ModelGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      name
      description
      color
      requireApproval
      status
      agents
      groupSettings
      numToUpgrade
      numToDowngrade
      upgradeGroup
      downgradeGroup
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGroupsQueryVariables,
  APITypes.ListGroupsQuery
>;
export const syncGroups = /* GraphQL */ `query SyncGroups(
  $filter: ModelGroupFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      name
      description
      color
      requireApproval
      status
      agents
      groupSettings
      numToUpgrade
      numToDowngrade
      upgradeGroup
      downgradeGroup
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncGroupsQueryVariables,
  APITypes.SyncGroupsQuery
>;
export const accountGroups = /* GraphQL */ `query AccountGroups(
  $accountID: String!
  $createdAtDeleted: ModelGroupByAccountCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  accountGroups(
    accountID: $accountID
    createdAtDeleted: $createdAtDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      name
      description
      color
      requireApproval
      status
      agents
      groupSettings
      numToUpgrade
      numToDowngrade
      upgradeGroup
      downgradeGroup
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AccountGroupsQueryVariables,
  APITypes.AccountGroupsQuery
>;
export const activeGroups = /* GraphQL */ `query ActiveGroups(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  activeGroups(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      name
      description
      color
      requireApproval
      status
      agents
      groupSettings
      numToUpgrade
      numToDowngrade
      upgradeGroup
      downgradeGroup
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveGroupsQueryVariables,
  APITypes.ActiveGroupsQuery
>;
export const getGroupSetting = /* GraphQL */ `query GetGroupSetting($id: ID!) {
  getGroupSetting(id: $id) {
    id
    groupID
    statusID
    needsVerification
    needsDeposit
    isDefault
    amount
    days
    timeSlots
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGroupSettingQueryVariables,
  APITypes.GetGroupSettingQuery
>;
export const listGroupSettings = /* GraphQL */ `query ListGroupSettings(
  $filter: ModelGroupSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listGroupSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      groupID
      statusID
      needsVerification
      needsDeposit
      isDefault
      amount
      days
      timeSlots
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGroupSettingsQueryVariables,
  APITypes.ListGroupSettingsQuery
>;
export const syncGroupSettings = /* GraphQL */ `query SyncGroupSettings(
  $filter: ModelGroupSettingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncGroupSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      groupID
      statusID
      needsVerification
      needsDeposit
      isDefault
      amount
      days
      timeSlots
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncGroupSettingsQueryVariables,
  APITypes.SyncGroupSettingsQuery
>;
export const statusSettings = /* GraphQL */ `query StatusSettings(
  $statusID: ID!
  $createdAtDeleted: ModelGroupSettingByStatusCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGroupSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  statusSettings(
    statusID: $statusID
    createdAtDeleted: $createdAtDeleted
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      groupID
      statusID
      needsVerification
      needsDeposit
      isDefault
      amount
      days
      timeSlots
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StatusSettingsQueryVariables,
  APITypes.StatusSettingsQuery
>;
export const activeGroupSettings = /* GraphQL */ `query ActiveGroupSettings(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGroupSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  activeGroupSettings(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      groupID
      statusID
      needsVerification
      needsDeposit
      isDefault
      amount
      days
      timeSlots
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveGroupSettingsQueryVariables,
  APITypes.ActiveGroupSettingsQuery
>;
export const getTimeline = /* GraphQL */ `query GetTimeline($id: ID!) {
  getTimeline(id: $id) {
    id
    actionName
    oldStatus
    newStatus
    bookingId
    customerId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTimelineQueryVariables,
  APITypes.GetTimelineQuery
>;
export const listTimelines = /* GraphQL */ `query ListTimelines(
  $filter: ModelTimelineFilterInput
  $limit: Int
  $nextToken: String
) {
  listTimelines(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      actionName
      oldStatus
      newStatus
      bookingId
      customerId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTimelinesQueryVariables,
  APITypes.ListTimelinesQuery
>;
export const syncTimelines = /* GraphQL */ `query SyncTimelines(
  $filter: ModelTimelineFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTimelines(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      actionName
      oldStatus
      newStatus
      bookingId
      customerId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTimelinesQueryVariables,
  APITypes.SyncTimelinesQuery
>;
export const activeTimelines = /* GraphQL */ `query ActiveTimelines(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTimelineFilterInput
  $limit: Int
  $nextToken: String
) {
  activeTimelines(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      actionName
      oldStatus
      newStatus
      bookingId
      customerId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveTimelinesQueryVariables,
  APITypes.ActiveTimelinesQuery
>;
export const getAdminRole = /* GraphQL */ `query GetAdminRole($id: ID!) {
  getAdminRole(id: $id) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminRoleQueryVariables,
  APITypes.GetAdminRoleQuery
>;
export const listAdminRoles = /* GraphQL */ `query ListAdminRoles(
  $filter: ModelAdminRoleFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminRolesQueryVariables,
  APITypes.ListAdminRolesQuery
>;
export const syncAdminRoles = /* GraphQL */ `query SyncAdminRoles(
  $filter: ModelAdminRoleFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdminRoles(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdminRolesQueryVariables,
  APITypes.SyncAdminRolesQuery
>;
export const activeRoles = /* GraphQL */ `query ActiveRoles(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminRoleFilterInput
  $limit: Int
  $nextToken: String
) {
  activeRoles(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveRolesQueryVariables,
  APITypes.ActiveRolesQuery
>;
export const getAdminGroup = /* GraphQL */ `query GetAdminGroup($id: ID!) {
  getAdminGroup(id: $id) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminGroupQueryVariables,
  APITypes.GetAdminGroupQuery
>;
export const listAdminGroups = /* GraphQL */ `query ListAdminGroups(
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminGroupsQueryVariables,
  APITypes.ListAdminGroupsQuery
>;
export const syncAdminGroups = /* GraphQL */ `query SyncAdminGroups(
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncAdminGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncAdminGroupsQueryVariables,
  APITypes.SyncAdminGroupsQuery
>;
export const activeAdminGroups = /* GraphQL */ `query ActiveAdminGroups(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  activeAdminGroups(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveAdminGroupsQueryVariables,
  APITypes.ActiveAdminGroupsQuery
>;
export const getUserConcepts = /* GraphQL */ `query GetUserConcepts($id: ID!) {
  getUserConcepts(id: $id) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserConceptsQueryVariables,
  APITypes.GetUserConceptsQuery
>;
export const listUserConcepts = /* GraphQL */ `query ListUserConcepts(
  $filter: ModelUserConceptsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      defaultConcept
      concepts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserConceptsQueryVariables,
  APITypes.ListUserConceptsQuery
>;
export const syncUserConcepts = /* GraphQL */ `query SyncUserConcepts(
  $filter: ModelUserConceptsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUserConcepts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      defaultConcept
      concepts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncUserConceptsQueryVariables,
  APITypes.SyncUserConceptsQuery
>;
export const getPoint = /* GraphQL */ `query GetPoint($id: ID!) {
  getPoint(id: $id) {
    id
    accountID
    amount
    expiry_date
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPointQueryVariables, APITypes.GetPointQuery>;
export const listPoints = /* GraphQL */ `query ListPoints(
  $filter: ModelPointFilterInput
  $limit: Int
  $nextToken: String
) {
  listPoints(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      amount
      expiry_date
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPointsQueryVariables,
  APITypes.ListPointsQuery
>;
export const syncPoints = /* GraphQL */ `query SyncPoints(
  $filter: ModelPointFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPoints(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      amount
      expiry_date
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPointsQueryVariables,
  APITypes.SyncPointsQuery
>;
export const activePoints = /* GraphQL */ `query ActivePoints(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPointFilterInput
  $limit: Int
  $nextToken: String
) {
  activePoints(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      amount
      expiry_date
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActivePointsQueryVariables,
  APITypes.ActivePointsQuery
>;
export const getTier = /* GraphQL */ `query GetTier($id: ID!) {
  getTier(id: $id) {
    id
    accountID
    conceptID
    name
    description
    imageUrl
    starting_value
    is_points_expire
    welcome_points
    points_gain_factor
    money_redeem_factor
    days_to_expire
    discount_rate
    discount_simphony_id
    customerCount
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTierQueryVariables, APITypes.GetTierQuery>;
export const listTiers = /* GraphQL */ `query ListTiers(
  $filter: ModelTierFilterInput
  $limit: Int
  $nextToken: String
) {
  listTiers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      conceptID
      name
      description
      imageUrl
      starting_value
      is_points_expire
      welcome_points
      points_gain_factor
      money_redeem_factor
      days_to_expire
      discount_rate
      discount_simphony_id
      customerCount
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTiersQueryVariables, APITypes.ListTiersQuery>;
export const syncTiers = /* GraphQL */ `query SyncTiers(
  $filter: ModelTierFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTiers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      conceptID
      name
      description
      imageUrl
      starting_value
      is_points_expire
      welcome_points
      points_gain_factor
      money_redeem_factor
      days_to_expire
      discount_rate
      discount_simphony_id
      customerCount
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncTiersQueryVariables, APITypes.SyncTiersQuery>;
export const activeTiers = /* GraphQL */ `query ActiveTiers(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTierFilterInput
  $limit: Int
  $nextToken: String
) {
  activeTiers(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      name
      description
      imageUrl
      starting_value
      is_points_expire
      welcome_points
      points_gain_factor
      money_redeem_factor
      days_to_expire
      discount_rate
      discount_simphony_id
      customerCount
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveTiersQueryVariables,
  APITypes.ActiveTiersQuery
>;
export const getTransaction = /* GraphQL */ `query GetTransaction($id: ID!) {
  getTransaction(id: $id) {
    id
    accountID
    conceptID
    customerID
    customerName
    checkNumber
    orderTotal
    paidAmount
    discountAmount
    employeeID
    employeeName
    revenueCentreName
    revenueCentreID
    points
    points_operation
    refundTrx
    refundAmount
    paymentStatus
    itemNames
    itemCounts
    orderedItems {
      symphonyID
      name
      quantity
      unitPrice
      totalPrice
      refunded
      __typename
    }
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionQueryVariables,
  APITypes.GetTransactionQuery
>;
export const listTransactions = /* GraphQL */ `query ListTransactions(
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      conceptID
      customerID
      customerName
      checkNumber
      orderTotal
      paidAmount
      discountAmount
      employeeID
      employeeName
      revenueCentreName
      revenueCentreID
      points
      points_operation
      refundTrx
      refundAmount
      paymentStatus
      itemNames
      itemCounts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsQueryVariables,
  APITypes.ListTransactionsQuery
>;
export const syncTransactions = /* GraphQL */ `query SyncTransactions(
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTransactions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accountID
      conceptID
      customerID
      customerName
      checkNumber
      orderTotal
      paidAmount
      discountAmount
      employeeID
      employeeName
      revenueCentreName
      revenueCentreID
      points
      points_operation
      refundTrx
      refundAmount
      paymentStatus
      itemNames
      itemCounts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTransactionsQueryVariables,
  APITypes.SyncTransactionsQuery
>;
export const transactionByUser = /* GraphQL */ `query TransactionByUser(
  $customerID: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  transactionByUser(
    customerID: $customerID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      customerID
      customerName
      checkNumber
      orderTotal
      paidAmount
      discountAmount
      employeeID
      employeeName
      revenueCentreName
      revenueCentreID
      points
      points_operation
      refundTrx
      refundAmount
      paymentStatus
      itemNames
      itemCounts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TransactionByUserQueryVariables,
  APITypes.TransactionByUserQuery
>;
export const activeTransactions = /* GraphQL */ `query ActiveTransactions(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  activeTransactions(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      conceptID
      customerID
      customerName
      checkNumber
      orderTotal
      paidAmount
      discountAmount
      employeeID
      employeeName
      revenueCentreName
      revenueCentreID
      points
      points_operation
      refundTrx
      refundAmount
      paymentStatus
      itemNames
      itemCounts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveTransactionsQueryVariables,
  APITypes.ActiveTransactionsQuery
>;
export const getOrderedItems = /* GraphQL */ `query GetOrderedItems($id: ID!) {
  getOrderedItems(id: $id) {
    id
    userID
    itemName
    conceptID
    count
    isGlobal
    createdAt
    createdByName
    deleted
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderedItemsQueryVariables,
  APITypes.GetOrderedItemsQuery
>;
export const listOrderedItems = /* GraphQL */ `query ListOrderedItems(
  $filter: ModelOrderedItemsFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderedItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      itemName
      conceptID
      count
      isGlobal
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderedItemsQueryVariables,
  APITypes.ListOrderedItemsQuery
>;
export const syncOrderedItems = /* GraphQL */ `query SyncOrderedItems(
  $filter: ModelOrderedItemsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncOrderedItems(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      userID
      itemName
      conceptID
      count
      isGlobal
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncOrderedItemsQueryVariables,
  APITypes.SyncOrderedItemsQuery
>;
export const activeOrders = /* GraphQL */ `query ActiveOrders(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderedItemsFilterInput
  $limit: Int
  $nextToken: String
) {
  activeOrders(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userID
      itemName
      conceptID
      count
      isGlobal
      createdAt
      createdByName
      deleted
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ActiveOrdersQueryVariables,
  APITypes.ActiveOrdersQuery
>;
